export const TOURS_LIMIT = 15;
export const TOUR_URL_PREFIX = "https://www.premiumexperiencesusa.com/admin/packages/configure-ticket-categories/id";
export const CATEGORY_OPS = {
	'SPORTS': 'sports',
	'CONCERTS': 'concerts',
	'THEATRE': 'theatre',
	'OTHER': 'other',
};
